import Caseshare from '@/pages/caseshare/Caseshare.vue'
import CaseDetail from '@/pages/caseshare/CaseDetail.vue'

// 案例分享相关路由数组
export const caseshareRoutes = [
  {
    path: '/caseshare',
    name: 'Caseshare',
    component: Caseshare,
    meta: {
      title: '案例分享'
    }
  },
  {
    path: '/caseshare/:id',
    name: 'CaseDetail',
    component: CaseDetail,
    meta: {
      title: '案例详情'
    }
  }
]

export default caseshareRoutes



// WEBPACK FOOTER //
// ./src/router/caseshare.js